import React, { PureComponent as Component } from "react";
import PropTypes from "prop-types";

export default class InternalContentContainer extends Component {
  render() {
    const { width, children, className } = this.props;

    return (
      <div
        className={`m-auto flex min-h-[calc(100vh-64px)] items-stretch pb-16 ${className}`}
        style={{ width }}
      >
        {children}
      </div>
    );
  }
}

InternalContentContainer.propTypes = {
  width: PropTypes.string.isRequired,
};
